import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { db } from "../db/firestore";
import { formatTime } from '../Utility/function';
import { initialPos, initialShop, initialVip } from '../configs';
import { NumberYMD } from '../Utility/dateTime';


const initialState = {
    shop:{}, // 
    modal_Shop:false,
    premiumEnable:false,
    memberEnable:false,
    staffEnable:false,
    warehouseEnable:false,
    deliveryEnable:false,
    shopFranchises:[]
}

  export const updateFieldShop = createAsyncThunk(
      'shop/updateFieldShop', async ({doc,field}) => {
      await db.collection('shop').doc(doc).update(field)
      return field;
  });

  function handleShop(data) {
    const { vip, cutOff, receipt, POSs, logo, imageUrl, ...rest } = { ...initialShop, ...data };
    const vipIds = new Set(vip.map(a => a.type));
    
    // Ensure all VIP types are included
    const newVip = [
      ...vip,
      ...initialVip.filter(a => !vipIds.has(a.type))
    ];

    // Get current date in comparable format once
    const currentDate = NumberYMD(new Date());

    // Define enabled states in a single object
    const enableTypes = {
      premium: false,
      member: false,
      staff: false,
      warehouse: false,
      delivery: false,
    };

    // Check for enabled VIP types using `some()`
    newVip.forEach(({ type, expire }) => {
      if (enableTypes.hasOwnProperty(type) && NumberYMD(formatTime(expire)) >= currentDate) {
        enableTypes[type] = true;
      }
    });
    return {
      shop: {
        ...rest,
        vip: newVip,
        cutOff: formatTime(cutOff),
        receipt,
        POSs: POSs.map(a => ({ ...initialPos, ...a })),
        logo: logo? logo:imageUrl.find(a=>a.type==='logo')?.value || ''
      },
      ...enableTypes, // Spread the enable states
    };
  }


export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    fetchNormalShopFranchise: (state, action) => {
      state.shopFranchises = action.payload
    },
    updateModal_Shop: state => {
      state.modal_Shop = !state.modal_Shop
    },
    fetchNormalShop: (state, action) => {
      const { shop, premium, member, staff, warehouse, delivery } = handleShop(action.payload)
      state.shop = shop
      state.premiumEnable = premium
      state.memberEnable = member
      state.staffEnable = staff
      state.warehouseEnable = warehouse
      state.deliveryEnable = delivery
    },

  },
  extraReducers: builder => {
    builder.addCase(updateFieldShop.pending, state => {
        state.modal_Shop = true
    })
    builder.addCase(updateFieldShop.fulfilled, (state, action) => {
        state.shop = {...state.shop,...action.payload}
        state.modal_Shop = false
    })
    builder.addCase(updateFieldShop.rejected, state => {
    state.modal_Shop = false
    })
  }
})

export const { 
  updateModal_Shop, 
  fetchNormalShop,
  fetchNormalShopFranchise
} = shopSlice.actions

export default shopSlice.reducer